<template>
  <v-container class="pr-0 pl-0" fluid>
    <v-card class="" >
      <v-card-text class="mb-5">
        <v-select
          :items="periodo"
          v-model="numeroDeDias"
          label="Período"
          item-text="name"
          @change="selecionaPeriodo"
          return-object
        ></v-select>
      </v-card-text>
    </v-card>

    <v-card class="elevation-10 mt-5" dense v-if="totalNatacao" :disabled="dialogLoader">
      <v-card-title class="">
        <v-icon left>mdi-swim</v-icon>
        Natação</v-card-title>
      <v-card-text class="text-justified">
        Você nadou {{formataNumeroBR(totalNatacao)}} metros
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        
      </v-card-actions>
    </v-card>

    <v-card class="elevation-10 mt-5" dense v-if="totalCorrida" :disabled="dialogLoader">
      <v-card-title class="">
        <v-icon left>mdi-run-fast</v-icon>
        Corrida</v-card-title>
      <v-card-text class="text-justified">
        Você correu {{formataNumeroBR(totalCorrida)}} Km
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        
      </v-card-actions>
    </v-card>

    <v-card class="elevation-10 mt-5" dense v-if="totalCiclismo" :disabled="dialogLoader">
      <v-card-title class="">
        <v-icon left>mdi-bike</v-icon>
        Ciclismo</v-card-title>
      <v-card-text class="text-justified">
        Você pedalou {{formataNumeroBR(totalCiclismo)}} Km
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        
      </v-card-actions>
    </v-card>

    <!-- loader -->
    <div class="text-center">
      <v-dialog v-model="dialogLoader" hide-overlay persistent width="300">
        <v-card color="primary" dark>
          <v-card-text class="pt-5">
            Espera um pouquinho...
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>

  </v-container>
</template>

<script>

//import axios from 'axios';
import HOST from '../ws'
import {myMixin} from '../mixin'
//import SnackBar from "../snackbar";


export default {

  props: {
    source: String
  },

  mixins : [
    myMixin
  ],

  beforeMount () {

    this.numeroDeDias = this.periodo[0];
    this.reloadTotaisList();
  },

  data: () => ({
    
    items : null,
    dialogLoader : false,

    totalCiclismo : null,
    totalNatacao : null,
    totalCorrida : null,

    numeroDeDias : null,

    periodo : [
      {name : 'Últimos 7 dias', dias : 7},
      {name : 'Ultimos 15 dias', dias : 15},
      {name : 'Últimos 30 dias', dias : 30},
      {name : 'Últimos 6 meses', dias : 180},
      {name : 'Último ano', dias : 365},
    ],
  }),

  methods : {

    selecionaPeriodo(){
      this.reloadTotaisList(); 
    },

    loadTotalNatacao(){

      const config = {
        headers: { Authorization: `Bearer ${this.$store.state.currentToken}` }
      };
      this.axios
      .post(HOST.HOST + '/treino/total/resumo/natacao/' + this.numeroDeDias.dias, {}, config)
      .then(response => {
        this.totalNatacao = response.data;
        this.dialogLoader = false;
        console.log('total natacao: ' + this.totalNatacao);
      })
      .catch((error) => {
        console.log(error.message);
        this.$store.commit('logout');
        this.$router.push("/");
      });
    },

    loadTotalCorrida(){

      const config = {
        headers: { Authorization: `Bearer ${this.$store.state.currentToken}` }
      };
      this.axios
      .post(HOST.HOST + '/treino/total/resumo/corrida/' + this.numeroDeDias.dias, {}, config)
      .then(response => {
        this.totalCorrida = response.data;
        this.dialogLoader = false;
        console.log('total corrida: ' + this.totalCorrida);
      })
      .catch((error) => {
        console.log(error.message);
        this.$store.commit('logout');
        this.$router.push("/");
      });
    },

    loadTotalCiclismo(){

      const config = {
        headers: { Authorization: `Bearer ${this.$store.state.currentToken}` }
      };
      this.axios
      .post(HOST.HOST + '/treino/total/resumo/ciclismo/' + this.numeroDeDias.dias, {}, config)
      .then(response => {
        this.totalCiclismo = response.data;
        this.dialogLoader = false;
        console.log('total ciclismo: ' + this.totalCiclismo);
      })
      .catch((error) => {
        console.log(error.message);
        this.$store.commit('logout');
        this.$router.push("/");
      });
    },

    reloadTotaisList(){
      this.dialogLoader = true;
      this.loadTotalNatacao();
      this.loadTotalCorrida();
      this.loadTotalCiclismo();
    }
  }
};
</script>